"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconSliders = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M1.25 19.6755 1.25 17.8046 8.3934 17.8046 8.3934 19.6755 1.25 19.6755ZM1.25 5.4454 1.25 3.5745 13.099 3.5745 13.099 5.4454 1.25 5.4454ZM10.0376 22 10.0376 15.4518 11.8801 15.4518 11.8801 17.8046 21.8866 17.8046 21.8866 19.6755 11.8801 19.6755 11.8801 22 10.0376 22ZM6.5509 14.8849 6.5509 12.5605 1.25 12.5605 1.25 10.6895 6.5509 10.6895 6.5509 8.3084 8.3934 8.3084 8.3934 14.8849 6.5509 14.8849ZM10.0376 12.5605 10.0376 10.6895 21.8866 10.6895 21.8866 12.5605 10.0376 12.5605ZM14.7432 7.7982 14.7432 1.25 16.5857 1.25 16.5857 3.5745 21.8866 3.5745 21.8866 5.4454 16.5857 5.4454 16.5857 7.7982 14.7432 7.7982Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconSliders')(IconSliders);